export const gridLayoutMap: Record<string, string> = {
  '1fr': 'grid:grid-cols-1 @2xl/grid:grid-cols-1',
  '2fr 1fr': 'grid:grid-cols-1 @2xl/grid:grid-cols-[2fr,1fr]',
  '1fr 2fr': 'grid:grid-cols-1 @2xl/grid:grid-cols-[1fr,2fr]',
  '1fr 1fr': 'grid:grid-cols-1 @2xl/grid:grid-cols-[1fr,1fr]',
  '3fr 2fr': 'grid:grid-cols-1 @2xl/grid:grid-cols-[3fr,2fr]',
  '2fr 3fr': 'grid:grid-cols-1 @2xl/grid:grid-cols-[2fr,3fr]',
}
